import axios from 'axios';

const api = axios.create({ baseURL: '/api' });

api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('access_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

let refreshing = null;
api.interceptors.response.use(
  r => r,
  async err => {
    const orig = err.config || {};
    const url = String(orig.url || '');
    const isAuthRoute = url.includes('/auth/login') || url.includes('/auth/refresh');
    if (isAuthRoute) return Promise.reject(err);
    if (err.response?.status === 401 && !orig._retry) {
      orig._retry = true;
      if (!refreshing) {
        refreshing = axios.post('/api/auth/refresh', {
          refresh_token: localStorage.getItem('refresh_token')
        }).then(r => {
          localStorage.setItem('access_token', r.data.access_token);
          localStorage.setItem('refresh_token', r.data.refresh_token);
          refreshing = null;
        }).catch(() => {
          localStorage.clear();
          window.location.href = '/login';
          refreshing = null;
        });
      }
      await refreshing;
      orig.headers.Authorization = `Bearer ${localStorage.getItem('access_token')}`;
      return api(orig);
    }
    return Promise.reject(err);
  }
);

export default api;
